import type { RawRows } from './types';

// Header row auto-detection. Ported from CPAiSuite Universal (spec §4.2 / Tech Spec §6.2).

const NAME_KEYWORDS = [
	'employee name',
	'emp name',
	'full name',
	'worker name',
	'first name',
	'last name',
	'surname',
	'employee',
	'worker',
	'associate',
	'staff',
	'name',
];

/**
 * Scan the first 20 rows for the first row that contains a name-column keyword
 * and has at least 3 non-empty cells. Falls back to the first non-empty row,
 * then to 0.
 */
export function findHeaderRow(rows: RawRows): number {
	const limit = Math.min(20, rows.length);
	for (let i = 0; i < limit; i++) {
		const row = rows[i];
		const nonEmpty = row.filter((c) => String(c).trim() !== '').length;
		if (nonEmpty < 3) continue;
		const joined = row.map((c) => String(c).toLowerCase()).join(' ');
		if (NAME_KEYWORDS.some((k) => joined.includes(k))) return i;
	}
	// Fallback: first non-empty row.
	for (let i = 0; i < rows.length; i++) {
		if (rows[i].some((c) => String(c).trim() !== '')) return i;
	}
	return 0;
}
